import Routes from 'Routes';
import { saveOldLocation } from '../../modules/actions';
import { saveAiPramas } from '../endorsedApply/modules/actions';
import { gspCollect, isCsairApp, gspNewVersion } from '@csair/emp-helpers';
import { loadStatusCodeMsg } from 'enEXchange';
import { createFanTaiSdk } from 'Utils';
import { compare } from 'Utils';

export default store => ({
  path: Routes.ticket.child.refundApply.key,
  onEnter(nextState, replace, callback) {
    function gointo() {
      window.sessionStorage.removeItem('pageButtonName');
      const { channel, flight, person } = nextState.location.query;
      loadStatusCodeMsg([
        'getNameAndPhone',
        'getVerificationCode',
        'createRefund',
        'createRefundTa',
        'submitFastRefundMultiple',
        'getRefundMode',
      ]);
      const {
        App: { oldLocation },
        EdorsedApply: { changeProcess, flightList, psgList },
      } = store.getState();

      console.log(store.getState());
      const flightArr = flight.split(',').sort(compare);
      const personArr = person.split(',').sort(compare);

      let originSelectFlight = flightList.filter(
        (item, i) => flightArr.indexOf(String(i)) !== -1
      );
      let originSelectpsg = psgList.filter(
        (item, i) => personArr.indexOf(String(i)) !== -1
      );

      window.$sensors.sensors.track(
        'flight_ticket_refund_and_change_page_view',
        {
          page_name:
            channel === 'TPWL'
              ? '机票退改-取消行程提交申请页'
              : '机票退改-退票提交申请页',
          channel_id: channel ? channel : '',
          ticket_number: originSelectpsg.map(obj => obj.ticketNo).join(';'),
          flight_date: originSelectFlight.map(obj => obj.flightDate).join(';'),
          flight_number: originSelectFlight.map(obj => obj.flightNo).join(';'),
          origin_location: originSelectFlight
            .map(obj => obj.depAirportName)
            .join(';'),
          destination_location: originSelectFlight
            .map(obj => obj.arrAirportName)
            .join(';'),
          passenger_type: originSelectpsg
            .map(obj =>
              obj.psgType === 3
                ? '婴儿'
                : obj.psgType === 1 || obj.psgType === 2
                ? '儿童'
                : '成人'
            )
            .join(';'),
          ticket_refund_type:
            channel === 'TPWL'
              ? '自愿退票'
              : originSelectpsg
                  .map(obj => obj.scopeCodes.join(';'))
                  .includes('fzytp')
              ? '非自愿退票'
              : '自愿退票',
        }
      );

      window.localStorage.removeItem('creatparmar');
      window.sessionStorage.setItem('historyUrl', oldLocation.pathname);
      callback();
    }
    function messageEvent(event) {
      window.removeEventListener('message', messageEvent);
      // 必须验证来源！
      if (event.origin.indexOf('csair.com') < 0) return;
      // { userId: 123, token: 'abc' }
      window.sessionStorage.setItem(
        'nextStepParams',
        JSON.stringify(event.data)
      );
      window.localStorage.setItem(
        'routeType',
        event.data.isDomestic ? '国内' : '国际'
      );
      window.sessionStorage.setItem('isAIComming', true);
      store.dispatch(saveAiPramas(event.data));
      gointo();
    }
    if (
      nextState.location.query.channel == 'AI' &&
      !nextState.location.query.from
    ) {
      if (window.ft && window.ft.miniProgram) {
        window.ft.getStorage({
          key: 'nextStepParams',
          success: data => {
            window.sessionStorage.setItem(
              'nextStepParams',
              JSON.stringify(data.data)
            );
            window.localStorage.setItem(
              'routeType',
              data.data.isDomestic ? '国内' : '国际'
            );
            window.sessionStorage.setItem('isAICommingFT', true);
            store.dispatch(saveAiPramas(data.data));
          },
          fail: data => {},
          complete: data => {
            gointo();
          },
        });
      }
    } else if (
      nextState.location.query.channel == 'AI' &&
      nextState.location.query.from === 'assistant'
    ) {
      if (
        /NHPAASWEBVIEW/i.test(navigator.userAgent) &&
        window.nh &&
        typeof window.nh.getStartupParams === 'function'
      ) {
        const data =
          typeof window.nh.getStartupParams() === 'string'
            ? JSON.parse(window.nh.getStartupParams())
            : {};
        window.sessionStorage.setItem('nextStepParams', JSON.stringify(data));
        window.localStorage.setItem(
          'routeType',
          data.isDomestic ? '国内' : '国际'
        );
        window.sessionStorage.setItem('isAIComming', true);
        store.dispatch(saveAiPramas(data));
        gointo();
      } else {
        window.addEventListener('message', messageEvent);
      }
    } else {
      gointo();
    }
  },
  onLeave(prevState) {
    window.sessionStorage.removeItem('nextStepParams');
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const Container = require('./components/Container').default;
        cb(null, Container);
      },
      'refundApply'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/refundApply/index.js